import React, { useState } from "react";
import { useNavigate } from "react-router-dom"; 
import { useAppData } from "../context/AppDataContext";
import { useSubscription } from "../hooks/useSubscription";
import { fetchAuthenticated } from "../utils/config";
import { API_BASE_URL } from "../utils/config";

function Profile() {
  // Destructure handleLogout from our context
  // To this:
  const { user: profile, loading, handleLogout,resetAppData, setIsDeactivating } = useAppData();
  const { isSubscribed, manageSubscription, subLoading } = useSubscription();

  const [showConfirm, setShowConfirm] = useState(false);
  const [deactivating, setDeactivating] = useState(false);

  const navigate = useNavigate(); 

const handleDeactivate = async () => {
    setDeactivating(true);
    try {
        const response = await fetchAuthenticated(`${API_BASE_URL}/userProfile/deactivateUser`, {
            method: "DELETE",
        });

        if (response.ok) {
            // 1. Tell the ProtectedLayout to STOP redirecting
            setIsDeactivating(true); 

            // 2. Clear the backend cookies
            await fetchAuthenticated(`${API_BASE_URL}/auth/signout`, { method: "POST" });

            // 3. Navigate to the safe page
            navigate("/goodbye");

            // 4. Wipe the state
            resetAppData(); 
        } else {
            alert("Failed to deactivate account.");
        }
    } catch (error) {
        console.error("Deactivation error:", error);
    } finally {
        setDeactivating(false);
    }
};

  if (loading) {
    return (
      <div className="page page--profile">
        <h1 className="page-title">Profile</h1>
        <div className="card profile-card">
          <p className="muted">Loading...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="page page--profile">
      <h1 className="page-title">Profile</h1>

      <div className="card profile-card">
        {/* Account Info */}
        <div className="profile-section">
          <h2>Account Information</h2>
          <p><strong>Email:</strong> {profile?.email}</p>
          <p><strong>Company:</strong> {profile?.companyName}</p>
        </div>

        <hr />

        {/* Subscription */}
        <div className="profile-section">
          <h2>Subscription</h2>
          <p>Status: <strong style={{ color: isSubscribed ? "#10b981" : "#ef4444" }}>
            {subLoading ? "Checking..." : isSubscribed ? "Active" : "Not Subscribed"}
          </strong></p>
          <button className="primary-btn" onClick={manageSubscription} disabled={subLoading || deactivating}>
            {isSubscribed ? "Manage Subscription" : "Start Subscription"}
          </button>
        </div>

        <hr />

        {/* Profile Settings */}
        <div className="profile-section">
          <h2>Profile Settings</h2>
          <button className="secondary-btn" onClick={() => alert("Coming soon")} disabled={deactivating}>
            Edit Profile
          </button>
        </div>

        <hr />

        {/* Account Actions */}
        <div className="profile-section">
          <h2>Account Actions</h2>
          
          <div style={{ display: "flex", flexDirection: "column", gap: "20px" }}>
            {/* Standard Logout Button - Now hitting the backend endpoint */}
            <button
              className="group-btn group-btn-primary"
              style={{ width: "fit-content" }}
              onClick={handleLogout}
              disabled={deactivating}
            >
              Log Out
            </button>

            {/* Deactivation Small Red Box */}
            {!showConfirm ? (
              <button 
                onClick={() => setShowConfirm(true)}
                style={{ 
                  color: "#ef4444", 
                  background: "none", 
                  border: "none", 
                  cursor: "pointer",
                  textAlign: "left",
                  fontSize: "0.85rem",
                  textDecoration: "underline",
                  padding: 0
                }}
              >
                Deactivate my account
              </button>
            ) : (
              <div style={{ 
                border: "1px solid #fca5a5", 
                backgroundColor: "#fff5f5", 
                padding: "16px", 
                borderRadius: "8px",
                maxWidth: "400px" 
              }}>
                <p style={{ color: "#991b1b", fontSize: "0.9rem", margin: "0 0 12px 0", fontWeight: "500" }}>
                  Warning: This cancels your subscription and disconnects all data.
                </p>
                <div style={{ display: "flex", gap: "10px" }}>
                  <button 
                    onClick={handleDeactivate}
                    disabled={deactivating}
                    style={{ 
                      backgroundColor: "#dc2626", 
                      color: "white", 
                      border: "none", 
                      padding: "6px 12px", 
                      borderRadius: "4px",
                      cursor: "pointer",
                      fontSize: "0.85rem"
                    }}
                  >
                    {deactivating ? "Wait..." : "Confirm Deactivation"}
                  </button>
                  <button 
                    onClick={() => setShowConfirm(false)}
                    disabled={deactivating}
                    style={{ 
                      backgroundColor: "transparent", 
                      color: "#4b5563", 
                      border: "1px solid #d1d5db", 
                      padding: "6px 12px", 
                      borderRadius: "4px",
                      cursor: "pointer",
                      fontSize: "0.85rem"
                    }}
                  >
                    Cancel
                  </button>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default Profile;